import { Form } from 'antd';
import { COLOR_WHITE } from 'constants/colors';
import styled from 'styled-components';
import { Tag } from 'UI';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1.5rem;
  background-color: ${COLOR_WHITE};
`;

export const HorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  align-items: center;
  padding-bottom: 1.5rem;
`;

export const OrderStatusFormContainer = styled(Form)`
  width: 100%;
`;

export const OrderOptionalInfoFormContainer = styled(Form)`
  width: 100%;
  padding-top: 1.5rem;
`;

export const BaseFormItem = styled(Form.Item)`
  margin: 0;
  padding-bottom: 1rem;

  & .ant-col,
  & .ant-form-item-control {
    width: 100%;
  }
`;

export const NotesInline = styled(BaseFormItem)`
  padding-bottom: 0;

  & .ant-col,
  & .ant-form-item-control {
    width: 100%;
    max-width: 100%;
  }
`;

export const CancelContainer = styled.div`
  width: fit-content;
  margin-top: 1.5rem;
`;

export const PopoverContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.375rem;
`;

export const StatusTag = styled(Tag)`
  margin-left: 1rem;
`;
